import { useApi } from "utils";
import { AgedType, FilterType } from "../../types";
import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { DataTypePaging } from "types";
import moment from "moment";

export function useList({ 
    page, 
    limit, 
    search,
    start_date,
    end_date,
    invoice_status,
    customer_id
}: FilterType) {

    const defaultValue = {
        payload: [],
        pagination_data: {
            page: 0,
            pages: 0,
            size: 0,
            total: 0
        }
    }

    const api = useApi();
    const [data, setData] = useState<DataTypePaging<AgedType>>(defaultValue);
    const [isLoading, setLoading] = useState(true)

    const params: { [key: string]: number | string | undefined } = {}
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    if (invoice_status) params.invoice_status = invoice_status;
    if (customer_id) params.customer_id = customer_id;

    const fetchUrl = () => {
        return api.get("/invoice/aged-receivable?",{params})
    }

    const fetchData = () => {
        setLoading(true);

        fetchUrl().then((res: SuccessFetch<DataTypePaging<AgedType>>) => {
            // Vars
            const payload = res.data.payload

            setData({
                ...res.data,
                payload: payload.map(item => {
                    // Vars
                    const date = moment(item.transaction_date)
                    const dueDate = moment()

                    return {
                        ...item,
                        aged_receivable: dueDate.diff(date, "days")
                    }
                })
            });
        }).catch(() => {
            setData(defaultValue);
        }).finally(() => {
            setLoading(false);
        });
    }

    const refetch = () => fetchData();

    useEffect(() => {
        fetchData();

        return () => {
            setData(defaultValue);
            setLoading(true);
        }
        // eslint-disable-next-line
    }, [page, limit, search, start_date, end_date, invoice_status, customer_id]);

    return { data, isLoading, refetch }
}
